import { render, staticRenderFns } from "./fccCorrecaoForm.vue?vue&type=template&id=5bd9fd64"
import script from "./fccCorrecaoForm.vue?vue&type=script&lang=js"
export * from "./fccCorrecaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports